import React, { useState } from "react";
import styles from '../styles/Header.module.css';

const initialHeader = {
  language_selection: "",
  logo: "",
  promotional_text: "",
  promotional_link: "",
  tracking_text: "",
  tracking_link: "",
  cart_link: "",
  wishlist_link: ""
};

export default function HeaderSettings() {
  const [header, setHeader] = useState(initialHeader);
  const [menu, setMenu] = useState([{ id: 1, name: "", link_to: "" }]);
  const [openHeader, setOpenHeader] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);

  const handleHeaderChange = (field, value) => {
    setHeader({ ...header, [field]: value });
  };

  const handleMenuChange = (idx, field, value) => {
    const updated = [...menu];
    updated[idx][field] = value;
    setMenu(updated);
  };

  const handleAddMenu = () => {
    setMenu([...menu, { id: Date.now(), name: "", link_to: "" }]);
  };
  const handleRemoveMenu = (idx) => {
    setMenu(menu.filter((_, i) => i !== idx));
  };

  const handleSave = () => {
    alert("Header data saved successfully (dummy)");
  };
  const handleCancel = () => {
    setHeader(initialHeader);
    setMenu([{ id: 1, name: "", link_to: "" }]);
    setOpenHeader(false);
  };

  // Icon SVGs
  const gridIcon = (
    <span className={styles.headerIcon}>
      <svg width="22" height="22" fill="#888" viewBox="0 0 20 20"><rect x="2" y="2" width="6" height="6" rx="1.5"/><rect x="12" y="2" width="6" height="6" rx="1.5"/><rect x="2" y="12" width="6" height="6" rx="1.5"/><rect x="12" y="12" width="6" height="6" rx="1.5"/></svg>
    </span>
  );
  const chevron = (open) => (
    <span className={styles.headerChevron + (open ? ' ' + styles.headerChevronOpen : '')}>
      <svg width="22" height="22" fill="#888" viewBox="0 0 20 20"><path d="M6 8l4 4 4-4" stroke="#888" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>
    </span>
  );

  return (
    <div className={styles.headerSettingsContainer}>
      {/* Header Content Collapsible */}
      <div className={styles.headerCard}>
        <div
          className={styles.headerCardHeader}
          onClick={() => setOpenHeader(v => !v)}
        >
          {gridIcon}
          <span className={styles.headerCardTitle}>Header Content</span>
          {chevron(openHeader)}
        </div>
        {openHeader && (
          <div className={styles.headerCardBody}>
            <div className={styles.headerFormRow}>
              <div className={styles.headerFormCol}>
                <label className={styles.headerLabel}>Language Selection</label>
                <input
                  className={styles.headerInput}
                  value={header.language_selection}
                  onChange={e => handleHeaderChange("language_selection", e.target.value)}
                />
              </div>
              <div className={styles.headerFormCol}>
                <label className={styles.headerLabel}>Logo</label>
                <input
                  className={styles.headerInput}
                  value={header.logo}
                  onChange={e => handleHeaderChange("logo", e.target.value)}
                />
              </div>
            </div>
            <div className={styles.headerFormRow}>
              <div className={styles.headerFormCol}>
                <label className={styles.headerLabel}>Promotional Text</label>
                <input
                  className={styles.headerInput}
                  value={header.promotional_text}
                  onChange={e => handleHeaderChange("promotional_text", e.target.value)}
                />
              </div>
              <div className={styles.headerFormCol}>
                <label className={styles.headerLabel}>Promotional Link</label>
                <input
                  className={styles.headerInput}
                  value={header.promotional_link}
                  onChange={e => handleHeaderChange("promotional_link", e.target.value)}
                />
              </div>
            </div>
            <div className={styles.headerFormRow}>
              <div className={styles.headerFormCol}>
                <label className={styles.headerLabel}>Tracking Text</label>
                <input
                  className={styles.headerInput}
                  value={header.tracking_text}
                  onChange={e => handleHeaderChange("tracking_text", e.target.value)}
                />
              </div>
              <div className={styles.headerFormCol}>
                <label className={styles.headerLabel}>Tracking Link</label>
                <input
                  className={styles.headerInput}
                  value={header.tracking_link}
                  onChange={e => handleHeaderChange("tracking_link", e.target.value)}
                />
              </div>
            </div>
            <div className={styles.headerFormRow}>
              <div className={styles.headerFormCol}>
                <label className={styles.headerLabel}>Cart Link</label>
                <input
                  className={styles.headerInput}
                  value={header.cart_link}
                  onChange={e => handleHeaderChange("cart_link", e.target.value)}
                />
              </div>
              <div className={styles.headerFormCol}>
                <label className={styles.headerLabel}>Wishlist Link</label>
                <input
                  className={styles.headerInput}
                  value={header.wishlist_link}
                  onChange={e => handleHeaderChange("wishlist_link", e.target.value)}
                />
              </div>
            </div>
            <div className={styles.headerButtonRow}>
              <button className={styles.headerSaveBtn} onClick={handleSave}>Save</button>
              <button className={styles.headerCancelBtn} onClick={handleCancel}>Cancel</button>
            </div>
          </div>
        )}
      </div>
      {/* Menu Items Collapsible */}
      <div style={{ background: "#fff", marginBottom: 24, boxShadow: "0 4px 8px #0001", borderRadius: 8 }}>
        <div
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '18px 24px 18px 18px', borderRadius: 8 }}
          onClick={() => setOpenMenu(v => !v)}
        >
          {gridIcon}
          <span style={{ fontWeight: 400, fontSize: 18, letterSpacing: 0.01 }}>Menu Items</span>
          {chevron(openMenu)}
        </div>
        {openMenu && (
          <div style={{ padding: 24, paddingTop: 0 }}>
            {menu.map((item, idx) => (
              <div key={item.id} style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
                <input
                  placeholder="Name"
                  style={{ marginRight: 8, padding: 4, borderRadius: 4, border: "1px solid #ccc", minWidth: 120 }}
                  value={item.name}
                  onChange={e => handleMenuChange(idx, "name", e.target.value)}
                />
                <select
                  style={{ marginRight: 8, padding: 4, borderRadius: 4, border: "1px solid #ccc", minWidth: 120 }}
                  value={item.link_to.startsWith('custom:') ? 'custom' : item.link_to}
                  onChange={e => {
                    const val = e.target.value;
                    if (val === 'custom') {
                      handleMenuChange(idx, 'link_to', 'custom:');
                    } else {
                      handleMenuChange(idx, 'link_to', val);
                    }
                  }}
                >
                  <option value="">Select Page</option>
                  <option value="/">Home</option>
                  <option value="/products">Products</option>
                  <option value="/categories">Categories</option>
                  <option value="/orders">Orders</option>
                  <option value="/support">Support</option>
                  <option value="custom">Custom Link</option>
                </select>
                {item.link_to.startsWith('custom:') && (
                  <input
                    placeholder="Enter URL"
                    style={{ marginRight: 8, padding: 4, borderRadius: 4, border: "1px solid #ccc", minWidth: 120 }}
                    value={item.link_to.replace('custom:', '')}
                    onChange={e => handleMenuChange(idx, 'link_to', 'custom:' + e.target.value)}
                  />
                )}
                <button style={{ marginLeft: 4, color: "red", border: "none", background: "none", cursor: "pointer" }} onClick={() => handleRemoveMenu(idx)} title="Delete Menu">🗑️</button>
              </div>
            ))}
            <button style={{ marginTop: 8, marginBottom: 8, border: "1.5px solid #b0bec5", borderRadius: 20, background: "#f8f9fa", color: "#333", fontWeight: 600, fontSize: 18, width: 36, height: 36, cursor: "pointer" }} onClick={handleAddMenu} title="Add Menu">＋</button>
            <button style={{ border: '1.5px solid #000', borderRadius: 8, background: 'rgba(227, 221, 221, 1)', color: "#000", fontWeight: 400, fontSize: 18, padding: "8px 24px", marginLeft: 16, cursor: "pointer" }} onClick={handleSave}>Save</button>
          </div>
        )}
      </div>
    </div>
  );
}
